module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-1.aeb847ab.png";